import * as Icon from 'react-bootstrap-icons';
import {Outlet, Link} from "react-router-dom";
import {useStore} from "../../store/store";
import {LoginModal} from "../Modal/LoginModal";
import {useEffect, useState} from "react";
import pmLogo from '../../assets/images/logo-pfalzmarkt.svg';
import {jwtDecode} from "jwt-decode";

export default function Header(props) {
    const [globalState, dispatch] = useStore();
    const[userNameInToken, setUserNameInToken ] = useState('');
    useEffect(() => {
        if (localStorage.getItem('token')) {
            setUserNameInToken(jwtDecode(localStorage.getItem("token")).username);
            dispatch('SET_AUTHTOKEN', localStorage.getItem('token'));
        } else {
            dispatch('SET_AUTHTOKEN', null);
            dispatch('IS_401_ERROR', true);
        }
    }, [globalState.token]);

    const [showModal, setShowModal] = useState();
    return (
        <><p></p>
            <LoginModal show={globalState.is401Error} onHide={() => setShowModal(false)}/>
            <ul className="nav nav-pills">
                {globalState.token && <>
                    <li className="nav-item">
                        <Link to="/" className="nav-link" href="#"><img src={pmLogo} alt="Home" width="70%"/></Link>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link "
                           href="https://qlik.pfalzmarkt.de/hub"
                           target='_blanc'>Portal – Qlik</a>
                    </li>
                    <li className="nav-item">
                        <Link to="/bestellungen" className="nav-link" href="#">Bestellungen</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/meldungen" className="nav-link" href="#">Meldung</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/telefonliste">Telefonliste</Link>
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link" to="/maschinenboerse">Maschinenbörse</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/streckengeschaeft">Streckengeschäft</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/abrechnungen">Abrechnungen</Link>
                    </li>
                    <li className="nav-item">
                        {//<Link  className="nav-link" to="/einstellungen"><Icon.FilePerson/> {userNameInToken}</Link>
                        }
                        <span className="nav-link">{userNameInToken}</span>
                        <Link className="nav-link" to="/logout"><Icon.DoorClosed/> Logout</Link>
                    </li>
                </>}
            </ul>

            <Outlet/>
        </>
    );
}